import { ORDER_FULFILLMENT_TYPES } from "../../../constants/sellarConstants.shared";

export type DeliveryOptions = ReturnType<typeof getDeliveryOptions>;

export const getDeliveryOptions = ({
  hiddenOptions,
  distribution,
}: {
  hiddenOptions: Array<
    | "ups"
    | "apc"
    | "sellarDistribution"
    | "collection"
    | "direct"
    | "courier"
    | "dx"
    | "dxDropOff"
  >;
  distribution?: {
    isSupplierEnabled: boolean;
    isBuyerInDistributionArea: boolean;
  };
}) => {
  return Object.values(ORDER_FULFILLMENT_TYPES)
    .filter(
      ({ value }) =>
        ![
          "dxBasic",
          "parcelforce",
          ...hiddenOptions,
          ...(distribution?.isSupplierEnabled ? [] : ["sellarDistribution"]),
        ].includes(value),
    )
    .filter(({ value }) => {
      if (!distribution?.isBuyerInDistributionArea) {
        return value !== "sellarDistribution";
      }
      return true;
    })
    .map(({ name, value }) => ({ name, value }));
};
